import { render, staticRenderFns } from "./changeAreaTemplateName.vue?vue&type=template&id=74747de0&scoped=true&"
import script from "./changeAreaTemplateName.vue?vue&type=script&lang=js&"
export * from "./changeAreaTemplateName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74747de0",
  null
  
)

export default component.exports